module.exports = __webpack_public_path__ + "static/img/yeswecan0005.e254f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0005.png
// module id = 571
// module chunks = 1